import { IPanelColumn, PanelColumnType } from '../types';
import { UnreachableCaseError } from 'ts-essentials';
import DetailsPanel from './DetailsPanel';
import ListPanel from './ListPanel';
import NoResultsPanel from './NoResultsPanel';

interface IProps {
  panel: IPanelColumn;
}

const Panel = ({ panel }: IProps) => {
  switch (panel.type) {
    case PanelColumnType.DETAILS:
      return <DetailsPanel panel={panel} />;
    case PanelColumnType.LIST:
      return <ListPanel panel={panel} />;
    case PanelColumnType.NO_RESULTS:
      return <NoResultsPanel />;
    default:
      throw new UnreachableCaseError(panel);
  }
};
export default Panel;
